import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  block: PropTypes.bool,
};

const PillButtonGroup = ({ className, children, block }) => {
  const classes = classNames({
    'pill-button-group': true,
    'pill-button-group-block': block,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      {React.Children.map(children, child => (
        <span className="pill-button-group-item">{child}</span>
      ))}
    </div>
  );
};

PillButtonGroup.propTypes = propTypes;

export default PillButtonGroup;
